export default __webpack_public_path__ + "static/media/nebula-grey.e923491b.svg";